/* eslint-disable import/prefer-default-export */
export const getCalls = (state) => state.StatisticsReducer.calls;
